module.exports = __webpack_public_path__ + "static/media/p2008coveri3.66c10595.jpg";